// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1Xqh0","itemTitle":"ClientEmergencyInfo_itemTitle__3Phi7","itemText":"ClientEmergencyInfo_itemText__2SHlA"};